import { useState } from 'react';

import { Button, List } from 'antd';
import Contact from 'app/components/Form/Controls/Contact';
import Panel from 'app/components/Layout/Panel';
import { FactoryListItem, SupplierListItem } from 'app/components/List';
import { Field, FieldArray, useFormikContext } from 'formik';
import classes from './Style.module.scss';
import { PlusCircleFilled } from '@ant-design/icons';
import { Searcher } from 'app/components/Searcher';
import {
  filterOutItems,
  filterOutNewlySelectedItems
} from 'app/pages/BookInspection/util';
import { toFactoryFormValue, toSupplierFormValue } from './util';
import { first } from 'lodash';

export default function Edit() {
  const { values } = useFormikContext();
  const [openSupplier, setOpenSupplier] = useState(false);
  const [openFactory, setOpenFactory] = useState(false);
  const { suppliers = [], factory } = values as any;
  const handleChangeSupplier = (field) => (selected) => {
    const existedSuppliers = filterOutItems(suppliers, selected);
    const newSelectedProducts = filterOutNewlySelectedItems(
      existedSuppliers,
      selected
    );
    const parsedSelectedSuppliers =
      newSelectedProducts.map(toSupplierFormValue);

    field.onChange({
      target: {
        name: field.name,
        value: [...existedSuppliers, ...parsedSelectedSuppliers]
      }
    });
    setOpenSupplier(false);
  };

  const handleChangeFactory = (field) => (selected) => {
    const selectedFactory = toFactoryFormValue(first(selected));

    field.onChange({
      target: {
        name: field.name,
        value:
          factory && factory.id !== selectedFactory.id
            ? selectedFactory
            : selectedFactory
      }
    });
    setOpenFactory(false);
  };

  return (
    <Panel
      className={classes.supplierFactory}
      contentClassName={classes.content}
    >
      <Field name="suppliers">
        {({ field }) => {
          return (
            <FieldArray name="suppliers">
              {(helper) => {
                return (
                  <>
                    <List
                      className={classes.list}
                      split={false}
                      header="Select Supplier"
                      dataSource={field.value}
                      footer={
                        <Button
                          type="link"
                          icon={<PlusCircleFilled />}
                          onClick={() => {
                            setOpenSupplier(true);
                          }}
                        >
                          Add Supplier
                        </Button>
                      }
                      renderItem={(supplier: any, index) => {
                        return (
                          <SupplierListItem
                            name={supplier.name}
                            supplierId={supplier.supplierId}
                            emails={supplier.supplierEmails}
                            contactPerson={supplier.contactPerson}
                            address={supplier.address1 || supplier.address2}
                            hideEmail
                            hideContactPerson
                            hideContactNo
                            extra={
                              <Button
                                onClick={() => {
                                  helper.remove(index);
                                }}
                                ghost
                                danger
                              >
                                Remove Supplier
                              </Button>
                            }
                          >
                            <Contact
                              fieldProps={{
                                contactPerson: {
                                  name: `${field.name}[${index}].contactPerson`
                                },
                                contactPersonEmail: {
                                  name: `${field.name}[${index}].contactPersonEmail`
                                },
                                contactPersonPhone: {
                                  name: `${field.name}[${index}].contactPersonPhone`
                                }
                              }}
                            />
                          </SupplierListItem>
                        );
                      }}
                    ></List>
                    <Searcher
                      open={openSupplier}
                      type="suppliers"
                      title="Select Supplier"
                      onOk={handleChangeSupplier(field)}
                      selected={field.value}
                      onBindingValue={(supplier) => {
                        const { email, supplierEmails, phoneNumber, phoneObj } =
                          supplier;
                        const phone = phoneObj
                          ? [phoneObj.code, phoneObj.number]
                              .filter((value) => !!value)
                              .join('')
                          : null;
                        const supplierEmail = email
                          ? { email }
                          : first(supplierEmails);

                        return {
                          ...supplier,
                          contactPersonPhone: phone || phoneNumber,
                          supplierEmails: supplierEmail ? [supplierEmail] : []
                        };
                      }}
                      onCancel={() => {
                        setOpenSupplier(false);
                      }}
                    />
                  </>
                );
              }}
            </FieldArray>
          );
        }}
      </Field>
      <Field name="factory">
        {({ field }) => {
          return (
            <Panel title="Select Factory" className={classes.factory}>
              {field.value && (
                <FactoryListItem
                  image={field.value.image}
                  factoryId={field.value.factoryId}
                  name={field.value.name}
                  address={field.value.address}
                  certifications={field.value.factoryCertifications}
                  extra={
                    <Button
                      type="primary"
                      ghost
                      onClick={() => {
                        setOpenFactory(true);
                      }}
                    >
                      Change
                    </Button>
                  }
                />
              )}
              {field.value && (
                <Contact
                  className={classes.contactField}
                  fieldProps={{
                    contactPerson: {
                      name: `${field.name}.contactPerson`
                    },
                    contactPersonEmail: {
                      name: `${field.name}.contactPersonEmail`
                    },
                    contactPersonPhone: {
                      name: `${field.name}.contactPersonPhone`
                    }
                  }}
                />
              )}
              {!field.value && (
                <Button
                  className={classes.selectFactoryBtn}
                  type="link"
                  onClick={() => {
                    setOpenFactory(true);
                  }}
                >
                  Select Existing Factory
                </Button>
              )}
              <Searcher
                open={openFactory}
                multiple={false}
                type="factories"
                title="Select Factory"
                onOk={handleChangeFactory(field)}
                selected={field.value ? [field.value] : []}
                onCancel={() => {
                  setOpenFactory(false);
                }}
              />
            </Panel>
          );
        }}
      </Field>
    </Panel>
  );
}
